export default "__VITE_ASSET__C4s8i5Tz__"